import React, { useContext, useEffect, useState } from 'react';
import { useMousePosition } from '../hooks/UseMousePosition';
import { InterfaceContext } from '../store/InterfaceProvider';
import SnapShotText from './SnapshotText';
import { getScaleObject } from '../store/StaticVariables';

const MapTooltip = () => {
    const mousePosition = useMousePosition();
    const { hoveredFeature, mapReadOnlyZoom, activeScale } = useContext(InterfaceContext);
    const [warnUserAboutScale, setWarnUserAboutScale] = useState(false);

    const validFeature = hoveredFeature.GEOID + '' !== '0' && hoveredFeature.NAME !== '';
    useEffect(() => {
        const scaleObj = getScaleObject(activeScale);
        const withinZoomRequirment = scaleObj.minZoom <= mapReadOnlyZoom;
        setWarnUserAboutScale(!withinZoomRequirment);
    }, [mapReadOnlyZoom, activeScale]);

    const withinMap = () => {
        const mapDom = document.querySelector('#map-view-container');
        if (!mapDom) return false;
        const mapBounds = mapDom.getBoundingClientRect();
        const tooHigh = mousePosition.y < mapBounds.y;
        const tooLow = mousePosition.y > mapBounds.bottom;
        const tooLeft = mousePosition.x < mapBounds.x;
        const tooRight = mousePosition.x > mapBounds.right;
        // console.log(mousePosition.x, mousePosition.y);
        // console.log('x', mapBounds.x, 'y', mapBounds.y, 'B', mapBounds.bottom, 'R', mapBounds.right);
        // console.log('x', tooLeft, 'y', tooHigh, 'B', tooLeft, 'R', tooRight);
        return !tooHigh && !tooLow && !tooLeft && !tooRight;
    };
    if (!withinMap()) return null;

    return (
        <div id="map-tooltip" style={{ left: mousePosition.x, top: mousePosition.y }}>
            {(validFeature || warnUserAboutScale) && (
                <>
                    <div className="tip-inner">
                        {validFeature && (
                            <div className="content">
                                <SnapShotText feature={hoveredFeature} details={false} />
                            </div>
                        )}
                        {warnUserAboutScale && (
                            <div className="content short">
                                <div>Zoom in to interact with the selected scale</div>
                            </div>
                        )}
                        <div className="arrow"></div>
                    </div>
                </>
            )}
        </div>
    );
};
export default MapTooltip;
